import DataTable from "@standard/components/DataTable";

const columns = [
  {
    label: "Name",
    name: "name",
    align: "left",
    sortable: true,
    search: { type: "text" },
  },
];

const config = {
  enableActive: false,
  enableEdit: true,
  enableTrash: true,
  enableView: true,
  onBeforeBind: (data) => {
    return data.map((item) => {
      return item;
    });
  },
};

export default ({ url }) => {
  return <DataTable columns={columns} url={url} {...config} />;
};
